import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GSMConfigurationService } from 'src/app/Service/gsmconfiguration.service';

@Component({
  selector: 'app-setparameter-thresoldvalue',
  templateUrl: './setparameter-thresoldvalue.html'
})
export class SetparameterthresoldvalueComponent implements OnInit {

  // Property Declaration
  setparameterForm: FormGroup;
  RoleName: string = '';
  DisplayButton: boolean = true; // Mayank
  SiteMasterList: any;
  IsreadOnly: boolean = false;
  IsreadOnly1: boolean = false;
  EnergyMeterId: string = '';
  Type: string = '';
  errorMsg: string = '';
  successMsg: string = '';
  UserId: number;
  IsfromAddSite: boolean = false;
  RegisterList: any;
  constructor(private GSMConfigService: GSMConfigurationService, private form: FormBuilder, private dialog: MatDialog, public dialogRef: MatDialogRef<SetparameterthresoldvalueComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
    if (data && data.SiteMasterList) {
      this.SiteMasterList = data.SiteMasterList;
      this.IsfromAddSite = data.IsfromAddSite;
      this.RegisterList = data.RegisterList;
    }
    if (data && data.EnergyMeterId) {
      this.EnergyMeterId = data.EnergyMeterId;
    }
  }

  ngOnInit(): void {
    this.RoleName = localStorage.getItem('RoleName');
    this.UserId = +localStorage.getItem('UserId');
    this.setparameterForm = this.form.group({
    });
    let obj = {};
    this.RegisterList.forEach(Register => (
      this.setparameterForm.addControl(Register.RegisterName, new FormControl('')),
      obj[Register.RegisterName] = Register.ThresoldValue
    ));
    this.setparameterForm.patchValue(obj);

    // Mayank
    if (this.RoleName == 'PortalAdmin') {
      this.DisplayButton = false;
      this.IsreadOnly = true;
    }
    else {
      this.DisplayButton = true;
      this.IsreadOnly = false;
    }
  }

  // Call on click Save button
  OnSubmit(): void {

    var Setparamvalue = { ...this.setparameterForm.value };

    this.successMsg = '';
    this.errorMsg = '';

    this.RegisterList.forEach(Register => (
      this.setparameterForm.addControl(Register.RegisterName, new FormControl('')),
      Register.HighThresoldValue = Setparamvalue[Register.RegisterName]
    ));
    // if(!this.IsfromAddSite){
    this.GSMConfigService.SaveRegisterThresoldvalue(this.RegisterList).subscribe(
      (result) => {

        if (result.Response == 'success') {
          this.successMsg = 'Values submitted successfully';
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // Call on click Cancel button
  OnCancel() {
    this.dialogRef.close();
  }

  // called on close icon
  Close() {
    this.dialogRef.close();
  }
}
